import { render, staticRenderFns } from "./ProjectHome.vue?vue&type=template&id=07371968&scoped=true&"
import script from "./ProjectHome.vue?vue&type=script&lang=js&"
export * from "./ProjectHome.vue?vue&type=script&lang=js&"
import style0 from "./ProjectHome.vue?vue&type=style&index=0&id=07371968&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07371968",
  null
  
)

export default component.exports